/*  eslint-disable jsx-a11y/click-events-have-key-events */
/*  eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import { withTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { Container } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import i18n from "../../i18n";
import userService from "../../services/Login/index";
import SwitchAccount from "./SwitchAccount";
import { isResMedDomainUser } from "../../utils/common";

const useStyles = makeStyles((theme) => ({
  topMenuContainer: {
    padding: theme.spacing(0),
    backgroundColor: "black",
    color: "white",
  },
  topMenu: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: theme.spacing(5),
    "& a": {
      color: "white",
    },
  },
  menu: {
    listStyle: "none",
    display: "flex",
    "& a": {
      color: "white",
      marginLeft: theme.spacing(2.5),
      textDecoration: "none",
    },
    "& a:hover": {
      textDecoration: "underline",
    },
  },
  listMycompany: {
    cursor: "pointer",
  },
  listMycompany1: {
    cursor: "not-allowed",
  },
}));

export const topBarMenu = () => {
  const classes = useStyles();
  const { VITE_REDIRECT_TO_OLD_URL, VITE_AU_HEADER_BASE_URL } = import.meta.env;
  const user = useSelector((state) => state.authentication);
  const setUser = useSelector((state) => state.setUser);
  const handleSignout = () => {
    // document.cookie = 'selectedAccount=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
    userService.logout();
  };
  const userEmail = useSelector(
    (state) => state.authentication?.user?.CP_USER_NAME || ""
  );
  
  const isEligibleForMyCompany =
    user?.user?.CP_USER_ROLE?.includes("Admin") &&
    user?.user?.CP_IS_CSR !== "Y" &&
    user?.user?.CP_IS_SALESREP !== "Y" &&
    !isResMedDomainUser(userEmail);

  return (
    <section className={classes?.topMenuContainer}>
      <Container maxWidth="lg">
        <div className={classes?.topMenu}>
          {user && <SwitchAccount loginUserInfo={user?.user} user={setUser} />}
          <ul className={classes?.menu}>
            {user?.myAccountPermission === "Y" ? (
              <li>
                <NavLink
                  to="/my-account"
                  className="nav-link"
                  id="TopMenu-LNK-myAccount"
                >
                  {" "}
                  {i18n.t("menuTitle.myAccount")}
                </NavLink>
              </li>
            ) : (
              <li>
                <a
                  href={`${VITE_REDIRECT_TO_OLD_URL}/myAccount.htm`}
                  id="TopMenu-LNK-myAccount"
                >
                  {i18n?.t("menuTitle.myAccount")}
                </a>
              </li>
            )}
            {
              isEligibleForMyCompany && (
                user?.myCompanyPermission === "Y" ? (
                  <li>
                    <NavLink
                      to="/my-company"
                      className="nav-link"
                      id="TopMenu-LNK-myCompany"
                    >
                      {i18n.t("menuTitle.myCompany")}
                    </NavLink>
                  </li>
                ) : (
                  <li>
                    <a
                      href={`${VITE_REDIRECT_TO_OLD_URL}/myCompany.htm`}
                      id="TopMenu-LNK-myCompany"
                    >
                      {i18n.t("menuTitle.myCompany")}
                    </a>
                  </li>
                )
              )
            }
            {user?.user?.CP_COUNTRY === "AU" && (
              <li>
                <a
                  href={`${VITE_AU_HEADER_BASE_URL}/rad-launch-pad?utm_source=ros`}
                  target="_blank"
                  rel="noreferrer"
                  id="TopMenu-LNK-rad"
                >
                  {i18n.t("menuTitle.rad")}
                </a>
              </li>
            )}
            <li className="list sign-out">
              <a onClick={handleSignout} id="TopMenu-LNK-logout">
                {i18n?.t("menuTitle.logout")}
              </a>
            </li>
          </ul>
        </div>
      </Container>
    </section>
  );
};

export default withTranslation()(topBarMenu);
